export default __webpack_public_path__ + "static/media/014-bridge.a79ef147.svg";